import React from "react";
import * as Yup from "yup";
import about from "../../assets/images/radarImage.jpg";
import "./about.css";


const AboutUsComponent = () => {

  return (
    <>

      <div className="container about-container">
        <div className="row about-row">
          <div className="col-lg-6 mb-0 order-2 order-lg-1 about-us-image">
            <img src={about} alt="SMART Committee" className="img-fluid rounded" />
            <div className="courtesy-text text-muted small mt-1">
              Courtesy: https://www.drdo.gov.in/drdo/labs-establishment/products<br/>
                   /electronics-radar-development-establishment-lrde
            </div>
          </div>

          <div className="col-lg-6 mb-0 order-2 order-lg-1 about-us-description">
            <h3
              style={{ textAlign: 'left' }}
            >
              {/* About SMART */}
              Aims and Objectives of Society for Microwaves, Antennas and Radar Technologies

            </h3>

            <ul style={{ paddingLeft: "20px", fontSize: '20px', marginTop:'15px' }}>
              <li
                style={{
                  lineHeight: "1.6",
                  // color: "#555",
                  marginBottom: "10px",
                  textAlign: "left",

                }}
              >
                Promote education, training, and engineering in Microwaves, Antennas, and
                Radar Technologies.
              </li>
              <li
                style={{
                  lineHeight: "1.6",
                  // color: "#555",
                  marginBottom: "10px",
                  textAlign: "left",
                }}
              >
                Organize conferences, symposiums, and exhibitions to showcase related
                technologies and advancements.
              </li>
              <li
                style={{
                  lineHeight: "1.6",
                  // color: "#555",
                  marginBottom: "10px",
                  textAlign: "left",
                }}
              >
                Publish reports, research papers, and expert insights on the field.
              </li>
              <li
                style={{
                  lineHeight: "1.6",
                  // color: "#555",
                  marginBottom: "10px",
                  textAlign: "left",
                }}
              >
                Encourage research and promote the development of innovative technologies
                in Microwaves, Antennas, and Radar Technologies.
              </li>
              <li
                style={{
                  lineHeight: "1.6",
                  // color: "#555",
                  marginBottom: "10px",
                  textAlign: "left",
                }}
              >
                Support invention and research by providing resources like books,
                equipment, and funding.
              </li>
              <li
                style={{
                  lineHeight: "1.6",
                  // color: "#555",
                  marginBottom: "10px",
                  textAlign: "left",
                }}
              >
                Train students to become self-reliant citizens and support institutions
                with similar objectives.
              </li>
              <li
                style={{
                  lineHeight: "1.6",
                  // color: "#555",
                  marginBottom: "10px",
                  textAlign: "left",
                }}
              >
                Establish research and development centers in science, technology,
                medicine, industry, and manufacturing.
              </li>
            </ul>
          </div>


        </div>
      </div>


    </>
  )
}
export default AboutUsComponent;

